import { useEffect } from 'react';

import { useAuth } from '@/features/auth/useAuth';

/**
 * Applies the signed-in venue's branding to the document.
 *
 * The product is sold to many venues, so accent colours, page title and favicon
 * are all per-venue settings rather than build-time constants. Overriding the
 * CSS variables on :root is enough — every component resolves its colours
 * through them (see styles/theme.css).
 */
export function VenueTheme() {
  const { venue } = useAuth();

  useEffect(() => {
    const root = document.documentElement;

    // Restore the built-in defaults when signed out, so the login screen never
    // inherits a previous venue's colours.
    const primary = venue?.primaryColor ?? null;
    const secondary = venue?.secondaryColor ?? null;

    if (primary) {
      root.style.setProperty('--brand-primary', primary);
    } else {
      root.style.removeProperty('--brand-primary');
    }

    if (secondary) {
      root.style.setProperty('--brand-secondary', secondary);
    } else {
      root.style.removeProperty('--brand-secondary');
    }
  }, [venue?.primaryColor, venue?.secondaryColor]);

  useEffect(() => {
    if (venue?.name) {
      document.title = venue.name;
    }
  }, [venue?.name]);

  return null;
}
